import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
export function HeroTestimonialSection() {
  return <div className="w-full bg-white border-t border-black/5 px-6 py-16 md:py-20" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-103">
          <div className="flex flex-col items-center mb-10" data-id="element-104">
            <span className="inline-block bg-teal-500 text-white text-xs font-black tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 shadow-md" data-id="element-105">
              Real Results
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-center leading-tight text-gray-900" data-id="element-106">
              Real Clients.{' '}
              <span className="relative inline-block" data-id="element-107">
                <span className="relative z-10 text-teal-600" data-id="element-108">
                  Real Lives Changed
                </span>
                <span className="absolute bottom-1 left-0 w-full h-3 bg-teal-100 -z-0 rounded" data-id="element-109" />
              </span>
            </h2>
          </div>
          <TestimonialCard headline={`After a Meeting With the Master, his heart doctor called our work a "borderline miracle."`} text={`Just wanted to share my transformation quickly with everyone. Since talking to Dr. Ali about 8 months ago I started my peptide regimen that was recommended to me based on having high cholesterol, low HDL, high LDL and having an ejection fraction of 35% (cardiomyopathy dx.)

Just recently in the last 2 weeks I had a blood panel done, echo of the heart and an angiogram for my arteries.

RESULTS:

My cholesterol dropped down from 250 to 150 and LDL and HDL are now within normal limits.

My ejection fraction is now at 60%.

I have ZERO plaque build up in my arteries.

My cardiologist was extremely surprised calling it a borderline miracle in 6 months. In fact he said my cardiomyopathy is now resolved and I no longer have that dx.

I want to thank Dr. Ali and the whole team as I plan to continue my life using daily peptides.

Thanks`} highlight={true} name="Jim C., Meeting With the Master client" data-id="element-110" />
        </motion.div>
      </div>
    </div>;
}